import { Box, Card, CardContent, Link } from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { Link as RouterLink, useNavigate } from "react-router-dom";

import { useGetAllPatients } from "../../api";
import { DataGridToolbar, useDataGrid } from "../../shared";
import { DataGridToolbarProps } from "../../shared/grid/DataGridToolbar";

const columns: GridColumns = [
  {
    field: "initials",
    headerName: "Initials",
    flex: 1,
    renderCell: ({ row }) => (
      <Link component={RouterLink} to={`/patients/${row.id}`}>
        {row.initials}
      </Link>
    ),
  },
  {
    field: "referenceId",
    headerName: "Patient Id",
    flex: 1,
    valueGetter: ({ row }) => row.referenceId,
  },
];

function Toolbar(props: Pick<DataGridToolbarProps, "onAdd" | "onSearch">) {
  const navigate = useNavigate();
  return (
    <DataGridToolbar
      header={"Patient List"}
      addButtonLabel="Add Patient"
      onAdd={() => navigate("/patients/add")}
      {...props}
    />
  );
}

interface Filters {
  searchQuery?: string;
}

function PatientList() {
  const { grid, query, updateSearchQuery } = useDataGrid<Filters>(
    "patients",
    columns
  );
  const { data, isFetching } = useGetAllPatients(
    {
      ...query,
    },
    { query: { keepPreviousData: true } }
  );

  function onSearchEntered(searchString: string) {
    updateSearchQuery({ searchQuery: searchString });
  }

  return (
    <Card elevation={0} sx={{ flex: 1 }}>
      <CardContent sx={{ flex: 1 }}>
        <Box sx={{ flex: 1 }}>
          <Box sx={{ display: "flex", height: "100%" }}>
            <Box sx={{ flexGrow: 1 }}>
              <DataGrid
                {...grid}
                rows={data?.items ?? []}
                rowCount={data?.total}
                loading={isFetching}
                components={{
                  Toolbar: Toolbar,
                }}
                componentsProps={{
                  toolbar: {
                    onSearch: (searchString: string) => {
                      onSearchEntered(searchString);
                    },
                    initialSearch: query.searchQuery,
                  },
                  pagination: {},
                }}
                autoHeight
              />
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export default PatientList;
